import type { TriggerSchema } from 'app/developer-v3/types';

export function isExternalTrigger(trigger: TriggerSchema) {
  return trigger?.key?.includes('external:');
}
